import CanalCobroCreate from './CanalCobroCreate'
export {CanalCobroCreate}
export default CanalCobroCreate
